import type { NotificationTab, UnreadCountResponse } from '../types/notification.types'

/** Orden de las pestañas de la campana (= orden de las flechas del teclado). */
export const NOTIFICATION_TABS: NotificationTab[] = ['ACTIVITY', 'NEWS']

/**
 * Pestaña con la que se abre la campana (spec R3): «Tus partidas», salvo que ahí no haya nada
 * sin leer y en Novedades sí.
 */
export function initialNotificationTab(unread: UnreadCountResponse | undefined): NotificationTab {
  return (unread?.activity ?? 0) === 0 && (unread?.news ?? 0) > 0 ? 'NEWS' : 'ACTIVITY'
}
